import React from 'react'
import ServicesPage from '../Components/ServicesPage/ServicesPage'

export default function Services() {
  return (
    <div>
      <ServicesPage/>
    </div>
  )
}
